import * as constants from "./constants";

export const loginRequest = (payload: any, route: string, history: any) => {
    return { type: constants.LOGIN_REQUESTING, payload, route, history }
}

export const loginSuccess = (payload: any) => {
    return { type: constants.LOGIN_SUCCESS, payload }
}

export const loginFailed = (error: any) => {
    return { type: constants.LOGIN_FAILED, error }
}

// Register
export const registerRequest = (payload: any, typeRoute: string, history: any) => {
    return { type: constants.REGISTER_REQUESTING, payload, typeRoute, history }
}

export const registerSuccess = (payload: any) => {
    return { type: constants.REGISTER_SUCCESS, payload }
}

export const registerFailed = (error: any) => {
    return { type: constants.REGISTER_FAILED, error }
}

// Verification OTP
export const verificationOtpRequest = (payload: any, typeRoute: string, history: any) => {
    return { type: constants.VERIFICATION_OTP_REQUESTING, payload, typeRoute, history }
}

export const verificationOtpSuccess = (payload: any) => {
    return { type: constants.VERIFICATION_OTP_SUCCESS, payload }
}

export const verificationOtpFailed = (error: any) => {
    return { type: constants.VERIFICATION_OTP_FAILED, error }
}

// Forgot password
export const forgotPasswordRequest = (payload: any, history: any) => {
    return { type: constants.FORGOT_PASSWORD_REQUESTING, payload, history }
}

export const forgotPasswordSuccess = (payload: any) => {
    return { type: constants.FORGOT_PASSWORD_SUCCESS, payload }
}

export const forgotPasswordFailed = (error: any) => {
    return { type: constants.FORGOT_PASSWORD_FAILED, error }
}

// Reset password
export const resetPasswordRequest = (payload: any, resetForm: () => void, history: any) => {
    return { type: constants.RESET_PASSWORD_REQUESTING, payload, resetForm, history }
}

export const resetPasswordSuccess = (payload: any) => {
    return { type: constants.RESET_PASSWORD_SUCCESS, payload }
}

export const resetPasswordFailed = (error: any) => {
    return { type: constants.RESET_PASSWORD_FAILED, error }
}

// Logout
export const logoutRequest = (history: any) => {
    return { type: constants.LOGOUT, history }
}
